import axios from "axios";
import ConstantList from "app/appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/dashboard/";
const API_PATH_EXCEL = ConstantList.API_ENPOINT + "/api/etb/download-file";

export const getByPatientType = () => {
  var url = ConstantList.API_ENPOINT + "/api/dashboard-patient-type";;
  return axios.get(url);
};

export const distributionChartByAgeAndSex = () => {
  var url = API_PATH + "distribution-chart-by-age-and-sex";;
  return axios.post(url);
};

export const getByPatientTypeHiv = () => {
  var url = ConstantList.API_ENPOINT + "/api/dashboard-patient-type/hiv";;
  return axios.get(url);
};

export const getDetecionTreatmentByUnit = (searchObject) => {
  var url = API_PATH + "detecion-treatment-by-unit";
  return axios.post(url, searchObject);
};

export const getDetecionTreatment = (searchObject) => {
  var url = API_PATH + "detecion-treatment";
  return axios.post(url, searchObject);
};

export const getDashboardSummary = (searchObject) => {
  var url = API_PATH + "summary";
  return axios.post(url, searchObject);
};

export const getDetecionTreatmentByYears = (searchObject) => {
  var url = ConstantList.API_ENPOINT + "/api/report-dashboard-administrative-unit/getDashboardAdministrativeUnit";
  return axios.post(url, searchObject);
};

export const exportDRTBDashboard = (obj) => {
  let url = API_PATH_EXCEL + "/export-drtb-dashboard";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
}
